import React from 'react';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { CommonSummaryInfoSubtitle } from 'src/components/EntityPage/CommonSummaryInfo/CommonSummaryInfo';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import _get from 'lodash/get';

export const BudgetBuilderSectionHeader = ({ title, description }: { title: string; description: string }) => {
  return (
    <div>
      <CommonSummaryInfoSubtitle title={title} includeSubtitle={false}></CommonSummaryInfoSubtitle>
      <BeaconSubtitleContainer>
        <Text variant="body1">{description}</Text>
      </BeaconSubtitleContainer>
    </div>
  );
};

export const BackNextButtons = ({
  canMoveBack,
  canMoveNext,
  onBackClick,
  onNextClick,
  onSaveClick,
  submitting
}: {
  canMoveBack?: boolean;
  canMoveNext?: boolean;
  onBackClick?: () => void;
  onNextClick?: () => void;
  onSaveClick?: () => void;
  submitting?: boolean;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      <SlButton disabled={!canMoveBack} onClick={onBackClick}>
        Back
      </SlButton>
      {onSaveClick ? (
        <SlButton variant="contained" onClick={onSaveClick}>
          {submitting ? 'Saving...' : 'Save'}
        </SlButton>
      ) : (
        <SlButton variant="contained" onClick={onNextClick} disabled={!canMoveNext}>
          Next
        </SlButton>
      )}
    </div>
  );
};

export const formatProfileList = (arr1: any[], arr2: any[]) => {
  const result = arr2.map((entity) => {
    const entityData = arr1.find((data) => data.fieldId === entity.id);
    return {
      ...entityData,
      id: entity.id,
      entity
    };
  });
  result.sort((a: any, b: any) => {
    const aValue = _get(a, ['spend', 'value'], -1);
    const bValue = _get(b, ['spend', 'value'], -1);
    return bValue - aValue;
  });
  return result;
};
